import React, { createContext, useContext, useMemo } from 'react';

type TabContextValue = {
	/**
	 * Whether or not the tab has overflowed before.
	 */
	hasOverflowed: boolean;
	id: string;
	isOverflowing: boolean;

	isSelected: boolean;
};

const TabContext = createContext<TabContextValue | null>(null);

export type TabProviderProps = TabContextValue & {
	children: React.ReactNode;
};

export const TabProvider = ({
	children,
	id,
	isOverflowing,
	hasOverflowed,
	isSelected,
}: TabProviderProps): React.JSX.Element => {
	const value = useMemo(
		() => ({
			id,
			isOverflowing,
			hasOverflowed,
			isSelected,
		}),
		[id, isOverflowing, hasOverflowed, isSelected],
	);

	return <TabContext.Provider value={value}>{children}</TabContext.Provider>;
};

export const useTabContext = () => {
	const context = useContext(TabContext);
	if (!context) {
		throw new Error('useTab must be used within a TabProvider');
	}
	return context;
};
